import MDBox from 'components/MDBox';
import MDButton from 'components/MDButton';
import MDTypography from 'components/MDTypography';
import { NavLink } from 'react-router-dom';

const entriesColumnData = [
  {
    Header: 'Player Username',
    accessor: 'player.username'
  },
  {
    Header: 'Player ID',
    accessor: 'player.id'
  },
  {
    Header: 'Amount',
    accessor: 'amount',
    Cell: ({ row }) => {
      return <>$</>;
    }
  },
  {
    Header: '',
    accessor: 'player-details',
    Cell: ({ row }) => {
      return (
        <>
          <MDBox sx={{ display: 'flex', justifyContent: 'center' }}>
            <NavLink to={`/players?search=${row.original.player.id}`}>
              <MDButton fontSize='0.875rem' color='info'>
                View
              </MDButton>
            </NavLink>
          </MDBox>
        </>
      );
    }
  }
];
export default entriesColumnData;
